/* istanbul ignore file */

import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';

import { applyCoupon } from '@yoimo/client-sdk/subscriptions';
import { ApplyCouponResponse, BillingPeriodicity } from '@yoimo/interfaces';

import { firstValueFrom, switchMap } from 'rxjs';

import { ScopeService } from '@core/services';

@Injectable({ providedIn: 'root' })
export class CouponService {
  constructor(
    private fs: Functions,
    private scopeService: ScopeService
  ) {}

  applyCoupon(
    couponCode: string,
    planId: string,
    periodicity: BillingPeriodicity,
    currency: string
  ): Promise<ApplyCouponResponse> {
    return firstValueFrom(
      this.scopeService
        .listenToChannel()
        .pipe(
          switchMap((channel) =>
            applyCoupon(
              this.fs,
              couponCode.trim(),
              channel.docId,
              planId,
              periodicity,
              currency
            )
          )
        )
    );
  }
}
